<script lang="ts">
	import { mdiHelpRhombus } from '@mdi/js';

	interface Props {
		mdiIcon?: string;
		viewBox?: string;
		style?: string;
		title?: string;
		color?: string;
		[key: string]: unknown;
	}

	let {
		mdiIcon = mdiHelpRhombus,
		viewBox = '0 0 24 24',
		style = '',
		title = '',
		color = 'currentColor',
		...rest
	}: Props = $props();
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	{viewBox}
	{style}
	class="smui-svg-icon"
	aria-hidden={title ? undefined : 'true'}
	role={title ? 'img' : undefined}
	{...rest}>
	{#if title}<title>{title}</title>{/if}
	<path fill={color} d={mdiIcon} />
</svg>

<style>
	.smui-svg-icon {
		display: inline;
		height: 1.5em;
		width: 1.5em;
		vertical-align: middle;
	}
</style>
